<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">

			<el-form-item label="缩略图" prop="house_number"><br>
				<el-upload class="upload-demo" ref="upload" action="https://jsonplaceholder.typicode.com/posts/"
					:on-preview="handlePreview" :on-remove="handleRemove" :on-change="uploadChange" :file-list="ruleForm.file"
					:auto-upload="false">
					<div style="display: flex;justify-content: space-between; width: 100%;">
						<el-button slot="trigger" size="small" type="primary" plain>
							<i class="el-icon-upload"></i>
							选取文件
						</el-button>
					</div>
				</el-upload>
			</el-form-item>
			<el-form-item label="状态" prop="status"><br>

				<el-radio v-model="inputmodel.status" label="1">启用</el-radio>
				<el-radio v-model="inputmodel.status" label="0">禁用</el-radio>
			</el-form-item>

		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		banner_edit,
		up_img
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: '',
				inputmodel: {
					aid: '',
					dir: '',
					status: ''
				},
				rules: {},
				ruleForm: {
					file: [],
				},
				wenjian1: '',
				imgchange: false,
			}
		},
		props: [
			"item"
		],
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					if (!this.wenjian1 || !(this.wenjian1 instanceof File)) {
						this.$message({
							message: '请选择图片',
							type: 'error'
						});
						return
					}
					const formData = new FormData()
					formData.append('image', this.wenjian1)

					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							if (this.imgchange) {
								up_img(formData).then(res => {
									console.log(res);
									this.inputmodel.aid = res.data.id
									this.inputmodel.dir = res.data.dir
									banner_edit(this.inputmodel).then(res => {
										this.Messages(res)
										if (res.status == 200) {
											this.inputmodel = {}
											this.$emit('changedia', false)
											this.$parent.$parent.$parent.contractlistcontractlist();
										}
									})
								})
							} else {
								banner_edit(this.inputmodel).then(res => {
									this.Messages(res)
									if (res.status == 200) {
										this.inputmodel = {}
										this.$emit('changedia', false)
										this.$parent.$parent.$parent.contractlistcontractlist();
									}
								})
							}
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			handleRemove(file, fileList) {
				this.wenjian1 = ''
			},
			handlePreview(file) {
				// console.log(file)
				console.log('点击', this.ruleForm.file)
			},
			uploadChange(file, fileList) {
				// 验证文件数量，替换后仅保留第一个文件
				if (fileList.length > 1) {
					fileList.splice(0, 1)
					console.log('文件1', fileList)
				}
				this.ruleForm.file = fileList
				this.wenjian1 = file.raw
				this.imgchange = true
			},
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			this.ruleForm.file = [{
				name: '文件'
			}]
			this.wenjian1 = [{
				name: '文件'
			}]
			if (this.item.status == '有效') {
				this.inputmodel.status = '1'
				console.log(this.inputmodel.status);
			} else {
				this.inputmodel.status = '0'
			}
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				this.ruleForm.file = [{
					name: '文件'
				}]
				this.wenjian1 = [{
					name: '文件'
				}]
				if (this.item.status == '有效') {
					this.inputmodel.status = '1'
					console.log(this.inputmodel.status);
				} else {
					this.inputmodel.status = '0'
				}
			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>